// pages/formularios/estilo.js — sx compartilhado da tela Formulários.
//
// Tudo por `var(--fm-*)` (Formularios.css), pra o mesmo componente servir
// no claro e no escuro. O MUI pinta campo, menu e diálogo com cores fixas
// do tema claro; estes helpers trocam pelos tokens.

export const SYNE = "'Syne', system-ui, sans-serif";
export const OUTFIT = "'Outfit', system-ui, sans-serif";

export const campo = {
  '& .MuiInputBase-root': { color: 'var(--fm-ink)', bgcolor: 'var(--fm-paper)' },
  '& .MuiOutlinedInput-notchedOutline': { borderColor: 'var(--fm-line)' },
  '& .MuiInputBase-root:hover .MuiOutlinedInput-notchedOutline': { borderColor: 'var(--fm-line-h)' },
  '& .MuiInputBase-root.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: 'var(--fm-focus)' },
  '& .MuiInputBase-root.Mui-error .MuiOutlinedInput-notchedOutline': { borderColor: 'var(--fm-red)' },
  '& .MuiInputLabel-root': { color: 'var(--fm-ink2)' },
  '& .MuiInputLabel-root.Mui-focused': { color: 'var(--fm-focus)' },
  '& .MuiInputLabel-root.Mui-error': { color: 'var(--fm-red)' },
  '& .MuiFormHelperText-root': { color: 'var(--fm-cap)', mx: 1.5 },
  '& .MuiFormHelperText-root.Mui-error': { color: 'var(--fm-red)' },
  '& .MuiSelect-icon': { color: 'var(--fm-ink3)' },
  '& .MuiInputBase-input::placeholder': { color: 'var(--fm-cap)', opacity: 1 },
  '& .Mui-disabled': { WebkitTextFillColor: 'var(--fm-dis-t)' },
};

export const menuPapel = {
  PaperProps: {
    sx: {
      bgcolor: 'var(--fm-paper)', color: 'var(--fm-ink)',
      border: '1px solid var(--fm-bdr)', backgroundImage: 'none',
      '& .MuiMenuItem-root:hover': { bgcolor: 'var(--fm-hover)' },
      '& .MuiMenuItem-root.Mui-selected': { bgcolor: 'var(--fm-sel)' },
      '& .MuiListSubheader-root': {
        bgcolor: 'var(--fm-paper)', color: 'var(--fm-cap)', lineHeight: '30px',
        fontSize: '0.68rem', fontWeight: 700, letterSpacing: '0.08em', textTransform: 'uppercase',
      },
    },
  },
};

export const dialogoPapel = {
  sx: {
    bgcolor: 'var(--fm-paper)', color: 'var(--fm-ink)', backgroundImage: 'none',
    border: '1px solid var(--fm-bdr)', borderRadius: 3,
  },
};

export const cartao = {
  border: '1px solid var(--fm-bdr)', borderRadius: '12px', bgcolor: 'var(--fm-paper)',
};

export const rotuloSecao = {
  fontFamily: SYNE, fontWeight: 700, fontSize: '0.8rem', color: 'var(--fm-label)',
};

export const ajuda = { fontSize: '0.74rem', color: 'var(--fm-cap)' };

export const botaoPrincipal = {
  textTransform: 'none', fontFamily: SYNE, fontWeight: 700, borderRadius: '10px',
  bgcolor: 'var(--fm-green)', color: 'var(--fm-on-green)', boxShadow: '0 4px 14px rgba(37,211,102,0.25)',
  '&:hover': { bgcolor: 'var(--fm-green)', filter: 'brightness(0.95)', boxShadow: '0 4px 14px rgba(37,211,102,0.3)' },
  '&.Mui-disabled': { bgcolor: 'var(--fm-dis-bg)', color: 'var(--fm-dis-t)', boxShadow: 'none' },
  '&:focus-visible': { outline: '2px solid var(--fm-focus)', outlineOffset: 2 },
};

export const botaoSecundario = {
  textTransform: 'none', fontFamily: SYNE, fontWeight: 700, borderRadius: '10px',
  color: 'var(--fm-title)', borderColor: 'var(--fm-bdr-h)', bgcolor: 'var(--fm-paper)',
  '&:hover': { borderColor: 'var(--fm-line-h)', bgcolor: 'var(--fm-hover)' },
  '&:focus-visible': { outline: '2px solid var(--fm-focus)', outlineOffset: 2 },
};

export const botaoTexto = {
  textTransform: 'none', fontWeight: 700, color: 'var(--fm-green-t)',
  '&:hover': { bgcolor: 'var(--fm-green-bg)' },
  '&:focus-visible': { outline: '2px solid var(--fm-focus)', outlineOffset: 2 },
};

const TONS = {
  green: { bg: 'var(--fm-green-bg2)', fg: 'var(--fm-green-t)' },
  amber: { bg: 'var(--fm-amber-bg)', fg: 'var(--fm-amber-t)' },
  red: { bg: 'var(--fm-red-bg)', fg: 'var(--fm-red)' },
  gray: { bg: 'var(--fm-chip)', fg: 'var(--fm-chip-t)' },
};
export const selo = (tom) => ({
  display: 'inline-flex', alignItems: 'center', gap: 0.5,
  px: 0.9, py: '2px', borderRadius: '6px', fontSize: '0.68rem', fontWeight: 700,
  bgcolor: (TONS[tom] || TONS.gray).bg, color: (TONS[tom] || TONS.gray).fg, whiteSpace: 'nowrap',
});
